import { TickmillProductType } from '@model/TickmillProductType'

export interface ProductValidationResult {
  isValid: boolean
  shouldResetToLeadProducts: boolean
}

export const isStocksOnlyLead = (leadProductIds: TickmillProductType[]): boolean => {
  return leadProductIds.length === 1 && leadProductIds[0] === TickmillProductType.STOCKS
}

export const getAllowedStocksOnlyProducts = (): TickmillProductType[] => {
  return [TickmillProductType.CFD, TickmillProductType.ETD, TickmillProductType.STOCKS]
}

export const validateProductSelection = (
  selectedProductIds: TickmillProductType[],
  leadProductIds: TickmillProductType[]
): boolean => {
  if (leadProductIds.length === 0) {
    return true
  }

  const hasAllLeadProducts = leadProductIds.every((id) => selectedProductIds.includes(id))
  const hasInvalidProducts = selectedProductIds.some((id) => !leadProductIds.includes(id))

  if (!hasInvalidProducts) {
    return hasAllLeadProducts
  }

  if (isStocksOnlyLead(leadProductIds)) {
    const allowedProducts = getAllowedStocksOnlyProducts()
    return hasAllLeadProducts && selectedProductIds.every((id) => allowedProducts.includes(id))
  }

  return false
}

export const getProductIdsToValidate = (
  signupContextProductIds: TickmillProductType[],
  localStorageProductIds: TickmillProductType[]
): TickmillProductType[] => {
  return signupContextProductIds.length > 0 ? signupContextProductIds : localStorageProductIds
}

export const validateAndSyncProductIds = (
  signupContextProductIds: TickmillProductType[],
  localStorageProductIds: TickmillProductType[],
  leadProductIds: TickmillProductType[]
): ProductValidationResult => {
  const productIdsToValidate = getProductIdsToValidate(
    signupContextProductIds,
    localStorageProductIds
  )

  if (productIdsToValidate.length === 0) {
    return {
      isValid: false,
      shouldResetToLeadProducts: leadProductIds.length > 0,
    }
  }

  const isValid = validateProductSelection(productIdsToValidate, leadProductIds)

  const shouldResetToLeadProducts = !isValid && leadProductIds.length > 0

  return {
    isValid,
    shouldResetToLeadProducts,
  }
}
